export const INT32_MAX = 2147483647;
export const INT32_MIN = -2147483648;
function toChirpFieldValue(value) {
  if (value === null || value === undefined) {
    return {
      '@type': 'null'
    };
  }
  if (typeof value === 'boolean') {
    return {
      '@type': 'boolean',
      value
    };
  }
  if (typeof value === 'number') {
    if (!Number.isInteger(value)) {
      return {
        '@type': 'double',
        value
      };
    }
    // Note: long values above Number.MAX_SAFE_INTEGER (2^53 - 1) cannot be
    // safely represented in JS and will lose precision silently.
    return value > INT32_MAX || value < INT32_MIN ? {
      '@type': 'long',
      value
    } : {
      '@type': 'integer',
      value
    };
  }
  if (typeof value === 'string') {
    return {
      '@type': 'string',
      value
    };
  }
  if (Array.isArray(value)) {
    return {
      '@type': 'list',
      value: value.map(v => toChirpFieldValue(v))
    };
  }
  return {
    '@type': 'map',
    value: Object.fromEntries(Object.entries(value).map(([k, v]) => [k, toChirpFieldValue(v)]))
  };
}
export function serializeContextForChirp(context) {
  return Object.fromEntries(Object.entries(context).map(([k, v]) => [k, toChirpFieldValue(v)]));
}